// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 897) return "static/chunks/897-eae75d9e2d370e37.js";
	if (chunkId === 107) return "static/chunks/107-19d6591da9b075e9.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"146":"datadog_browser_logs","340":"layout__client_site_chrome_ui","367":"layout__minimal","748":"datadog_browser_rum"}[chunkId] || chunkId) + "." + {"146":"c4d2703491ec6ef1","205":"2e90144ef4045da8","319":"0cbc2894a3f1b950","340":"247204414d6e4b6a","367":"4a3beea1fc4722b4","639":"69beb01a70ce4821","748":"82561939aeae8625"}[chunkId] + ".js";
};